import { useState, useEffect } from 'react'

import styles from '../../TechPartnerDashboard/TechPartnerDashboard.module.scss'
import '../../TechPartnerDashboard/TechPartnerDashboard.scss'

import { fetchTeamResources, TeamResourcesSalesData } from '../../../features/sales/salesAPI'

import { TechPartnerDashboardDataSectionProps } from '../TechPartnerDashboardSection'
import { TeamResourcesGrid } from './TeamResourcesGrid'

export const TeamResourcesData = (props: TechPartnerDashboardDataSectionProps) => {
    const [teamResourcesDataPayload, setTeamResourcesDataPayload] = useState<
        TeamResourcesSalesData[]
    >([])
    const [salesManagerCount, setSalesManagerCount] = useState<number>(0)
    const [outsideSalesCount, setOutsideSalesCount] = useState<number>(0)
    const [appEngineerCount, setAppEngineerCount] = useState<number>(0)
    const [insideSalesCount, setInsideSalesCount] = useState<number>(0)

    useEffect(() => {
        if (Object.keys(props.selectedInputs).length === 0) return

        props.onLoadingChange(true)

        getTeamResourcesData()
    }, [props.selectedInputs])

    useEffect(() => {
        setSalesManagerCount(
            teamResourcesDataPayload.filter(
                (r) => r.Department.toLowerCase().indexOf('sales manager') > -1
            ).length
        )
        setOutsideSalesCount(
            teamResourcesDataPayload.filter(
                (r) => r.Department.toLowerCase().trim() === 'outside sales'
            ).length
        )
        setAppEngineerCount(
            teamResourcesDataPayload.filter(
                (r) => r.Department.toLowerCase().indexOf('engineer') > -1
            ).length
        )
        setInsideSalesCount(
            teamResourcesDataPayload.filter(
                (r) => r.Department.toLowerCase().trim() === 'inside sales'
            ).length
        )
        props.onLoadingChange(false)
    }, [teamResourcesDataPayload])

    const getTeamResourcesData = () => {
        let dataTeamResources: TeamResourcesSalesData[]

        async function getCustomers(controller: AbortController) {
            if (Object.keys(props.selectedInputs).length === 0) return

            dataTeamResources = await fetchTeamResources(props.selectedInputs, controller)
        }

        const asyncFunctions = [getCustomers]
        const callAsyncFunctions = async () => {
            await Promise.all(
                asyncFunctions.map(async (get) => {
                    const controller = new AbortController()
                    await get(controller)
                })
            )
        }

        callAsyncFunctions().then(() => {
            if (dataTeamResources) setTeamResourcesDataPayload(dataTeamResources)
        })
    }

    useEffect(
        () =>
            props.onTitleBarTextChange &&
            props.onTitleBarTextChange(
                <div className={styles.teamResourcesTitle}>
                    <span>Sales Managers: {salesManagerCount}</span>
                    <span>Outside Sales: {outsideSalesCount}</span>
                    <span>App Engr: {appEngineerCount}</span>
                    <span>Inside Sales: {insideSalesCount}</span>
                </div>
            ),
        [salesManagerCount, outsideSalesCount, appEngineerCount, insideSalesCount]
    )

    return (
        <div className={`${styles.teamResources} team-resources`} id='team-resources'>
            <TeamResourcesGrid data={teamResourcesDataPayload} />
        </div>
    )
}

export default TeamResourcesData
